import { Login } from '@lune/auth/login'
import React from 'react'
import logo from '../../assets/logo.png'
import { version } from '../api/version'
import { AppName } from '../constants'
import {
  LoginApiUrl,
  LoginFailedPage,
  LoginPage as LoginPageUrl,
  LoginSuccessPage,
  Root
} from '../paths'

export const LoginPage = (): React.JSX.Element => (
  <Login
    name={AppName}
    icon={<img src={logo} width={96} height={96} alt="app-logo" />}
    paths={{
      LoginApiUrl,
      LoginSuccessUrl: LoginSuccessPage,
      LoginFailedUrl: LoginFailedPage,
      RootUrl: Root
    }}
    redirectOnLoggedIn={{
      ApiVersion: version,
      LoginUrl: LoginPageUrl
    }}
  />
)
